import { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { toMin, totalMinGrupo } from './professorUtils';
import { TimelineAulas } from './TimelineAulas';
import { TurnoAuxiliar } from './TurnoAuxiliar';

/**
 * TimelineGrupos — agrupa aulas por turno e renderiza com turnos auxiliares PRE/POS
 */
export function TimelineGrupos({ grupos, idxAtivo, statusMap, horarioAtual, intervaloAtual: _intervaloAtual, proximaAula, agoraMin, chamadasDia, navigate, dataSelecionada }: {
  grupos: any[]; idxAtivo: number; statusMap: Record<string, string>; horarioAtual: any;
  intervaloAtual: any; proximaAula: any; agoraMin: number; chamadasDia: any[]; navigate: (p: string) => void;
  dataSelecionada: string;
}) {
  const [expandedIdxs, setExpandedIdxs] = useState<Set<number>>(new Set());

  const toggleIdx = (idx: number) => {
    setExpandedIdxs(prev => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx); else next.add(idx);
      return next;
    });
  };

  const primeiroTurnoInicio = grupos.length > 0 ? grupos[0].inicio : '07:00';
  const ultimoTurnoFim = grupos.length > 0 ? grupos[grupos.length - 1].fim : '17:00';

  const renderGrupoHeader = (grupo: any, isAtivo: boolean, onClick?: () => void) => {
    const aulasDoGrupo = grupo.aulas.filter((h: any) => h.tipo !== 'INTERVALO');
    const feitasGrupo = aulasDoGrupo.filter((h: any) => statusMap[h.id] === 'CONCLUIDA').length;
    const totalGrupo = aulasDoGrupo.length;
    const todasFeitas = totalGrupo > 0 && feitasGrupo === totalGrupo;
    const totalMin = totalMinGrupo(grupo.aulas);
    const duracaoTurno = totalMin < 60 ? `${totalMin} min` : totalMin % 60 === 0 ? `${Math.floor(totalMin/60)}h` : `${Math.floor(totalMin/60)}h ${String(totalMin%60).padStart(2,'0')}min`;

    return (
      <div
        style={{
          display: 'flex', alignItems: 'center', gap: 8, padding: '5px 4px', marginBottom: 2,
          cursor: onClick ? 'pointer' : 'default', userSelect: 'none',
          borderRadius: 6, transition: 'background 0.15s',
        }}
        onClick={onClick}
        onMouseEnter={e => { if (onClick) (e.currentTarget as HTMLDivElement).style.background = '#f8fafc'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLDivElement).style.background = 'transparent'; }}
      >
        <div style={{
          width: 6, height: 6, borderRadius: '50%',
          background: isAtivo ? '#16a34a' : '#cbd5e1', flexShrink: 0,
        }} />
        <span style={{ fontSize: '0.72rem', fontWeight: 600, color: isAtivo ? '#16a34a' : '#94a3b8', textTransform: 'uppercase' }}>
          {grupo.nome}
        </span>
        <span style={{ fontSize: '0.63rem', color: '#b0b8c4' }}>
          {grupo.inicio} &ndash; {grupo.fim}
        </span>
        <span style={{ fontSize: '0.6rem', fontWeight: 600, color: todasFeitas ? '#16a34a' : '#b0b8c4', marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 4 }}>
          {feitasGrupo}/{totalGrupo} · {duracaoTurno}
          {todasFeitas && <CheckCircle2 size={11} color="#16a34a" />}
        </span>
      </div>
    );
  };

  return (
    <>
      <TurnoAuxiliar
        tipo="PRE"
        primeiroTurnoInicio={primeiroTurnoInicio}
        ultimoTurnoFim={ultimoTurnoFim}
        dataSelecionada={dataSelecionada}
        disabled={false}
        isAtivo={agoraMin < toMin(primeiroTurnoInicio)}
        agoraMin={agoraMin}
      />

      {grupos.map((grupo, idx) => {
        const isAtivo = idx === idxAtivo;
        const emPreparacao = idxAtivo === -1 && agoraMin < toMin(primeiroTurnoInicio);
        // Turnos passados colapsados por padrao; ativo sempre expandido; futuro colapsado
        const turnoPassado = !isAtivo && grupo.fim && toMin(grupo.fim) < agoraMin;
        const isExpanded = isAtivo || expandedIdxs.has(idx);

        return (
          <div key={grupo.nome} style={{ marginBottom: 6, opacity: emPreparacao ? 0.55 : turnoPassado ? 0.6 : 1, transition: 'opacity 0.3s' }}>
            {renderGrupoHeader(grupo, isAtivo, isAtivo ? undefined : () => toggleIdx(idx))}
            {isExpanded && (
              <TimelineAulas
                aulas={grupo.aulas} statusMap={statusMap} horarioAtual={horarioAtual}
                proximaAula={proximaAula} agoraMin={agoraMin} chamadasDia={chamadasDia}
                navigate={navigate} showAll={!isAtivo}
              />
            )}
          </div>
        );
      })}

      <TurnoAuxiliar
        tipo="POS"
        primeiroTurnoInicio={primeiroTurnoInicio}
        ultimoTurnoFim={ultimoTurnoFim}
        dataSelecionada={dataSelecionada}
        disabled={agoraMin < toMin(ultimoTurnoFim) && grupos.some(g => g.aulas.some((a: any) => statusMap[a.id] !== 'CONCLUIDA'))}
        isAtivo={agoraMin >= toMin(ultimoTurnoFim)}
        agoraMin={agoraMin}
      />
    </>
  );
}
